import React from "react"
import { Container } from "@mui/material"

export const InputWrapper: React.FC<any> = ({ children, customWidth }) => {
    return (
      <Container disableGutters sx={{ display: "flex", justifyContent: "space-between", width: customWidth ? customWidth : "852px", height: "56px" }}>
        {children}
      </Container>
    )
}